module.exports = {
  Loading: require('./loading.gif'),
  HomeLogo: require('./home-logo.png'),
};
